import React, { useContext } from 'react';
import { Modal } from 'react-bootstrap';
// import { BASE_URL_STATIC } from '../../../../../../config';
import { ApiContext } from '../../../UseContext/ApiCall';
import { BASE_URL_STATIC } from '../../../../../config';


const CnpSelectGifPopup = () => {

  const {
    setShowCreateNewPostPopup,
    setCnpSelectedPhotoVideo,
    setCnpPreviouslyOpenedPopup,
    setCnpSelectedTextBackground,

    showCnpSelectGifPopup, setShowCnpSelectGifPopup,
    setShowCnpGifPopup,
    cnpGifSearchText, setCnpGifSearchText,
    cnpGifs, setCnpGifs,
    cnpSearchedGifs, setCnpSearchedGifs,
    cnpSelectedGif, setCnpSelectedGif,
    showCnpGifLoadMore, setShowCnpGifLoadMore,
    getGifs,
  } = useContext(ApiContext);


  // handle search change 
  const handleSearchChange = (e) => {
    console.log('value : ', e.target.value);

    setCnpGifSearchText(e.target.value);

    if(e.target.value === '') {
      getGifs('');
      setCnpSearchedGifs([]);
    } else {
      setCnpSearchedGifs([]);
      getGifs(e.target.value);
    };
  };

  // handle gif load more
  const handleGifLoadMore = () => {
    setShowCnpGifLoadMore(false);
    getGifs(cnpGifSearchText);
  };

  // handle select gif
  const handleSelectGif = (selectedGif) => {
    setCnpSelectedGif(selectedGif);

    setCnpGifs(preState => preState.filter(gif => gif !== selectedGif));

    if(cnpSelectedGif !== '') {
      setCnpGifs(preState => [ ...preState, cnpSelectedGif ]);
    };

    setCnpSelectedPhotoVideo([
      {
        file: {
          type: 'image',
        },
        tags: []
      }
    ]);

    setShowCnpSelectGifPopup(false);
    setShowCnpGifPopup(true);
    setCnpPreviouslyOpenedPopup('gif');
    setCnpSelectedTextBackground('');
  };

  // handle remove selected gif
  const handleRemoveSelectedGif = () => {
    setCnpGifs(preState => [ cnpSelectedGif, ...preState ])

    setCnpSelectedGif('');
  };

  // handle close select gif popup
  const handleCloseSelectGifPopup = () => {
    setShowCnpSelectGifPopup(false);
    setShowCreateNewPostPopup(true);
  };
  

  return (
    <>
      <Modal show={showCnpSelectGifPopup} onHide={handleCloseSelectGifPopup} centered backdrop="static" keyboard={false} className="main-modal" >
      {/* <Modal show={true} onHide={handleCloseSelectGifPopup} centered backdrop="static" keyboard={false} className="main-modal" > */}
        <Modal.Header className='mb-3 pt-0' closeButton>
          <h5 className='flex-grow-1 text-center pt-3'>Select Gif</h5>
        </Modal.Header>

        <Modal.Body>
          {/* Search Bar */}
          <div className="d-flex flex-grow-1 rounded-pill bg-body-secondary p-1 p-sm-2">
            <img className="mx-2" src={`${BASE_URL_STATIC}/icon/search.svg`} alt="search" />

            <input type="search" className="rounded-pill bg-body-secondary w-100 border-0" id="search" name="search" autoComplete='false' placeholder="GIF by Tenor..." 
              value={cnpGifSearchText} onChange={handleSearchChange}
            />
          </div>

          <div className='border my-3 overflow-y-scroll bg-light p-2' style={{ maxHeight: '43vh' }}>
            {
              (cnpSearchedGifs && cnpSearchedGifs.length > 0)
              ?
              // Searched Gifs
              <div className='d-flex flex-wrap gap-2'>
                {
                  cnpSearchedGifs.map((value, index) => (
                    <div className={`${(value === cnpSelectedGif) ? 'border border-primary border-2 shadow-sm' : 'border' } px-0 rounded-3 cursor-pointer`} 
                      style={{ height: '125px', width: '31%' }} onClick={() => handleSelectGif(value)} key={index}
                    >
                      <img src={value} className='h-100 w-100 rounded-3' alt="gif" />
                    </div>
                  ))
                }
              </div>
              :
              <div className='d-flex flex-wrap gap-2'>
                {/* Selected Gif */}
                <>
                  {
                    (cnpSelectedGif !== '')
                    &&
                    <div className={`border border-primary border-2 shadow-sm px-0 rounded-3 cursor-pointer`} 
                      style={{ height: '125px', width: '31%' }} onClick={handleRemoveSelectedGif}
                    >
                      <img src={cnpSelectedGif} className='h-100 w-100 rounded-3' alt="gif" />
                    </div>
                  }
                </>

                {
                  (cnpGifs && cnpGifs.length > 0)
                  &&
                  cnpGifs.map((value, index) => (
                    <div className={`${(value === cnpSelectedGif) ? 'border border-primary border-2 shadow-sm' : 'border' } px-0 rounded-3 cursor-pointer`} 
                      style={{ height: '125px', width: '31%' }} onClick={() => handleSelectGif(value)} key={index}
                    >
                      <img src={value} className='h-100 w-100 rounded-3' alt="gif" />
                    </div>
                  ))
                }
              </div>
            }

            {/* Load More */}
            <>
              {
                showCnpGifLoadMore
                &&
                <div className='text-center mt-3 mb-1'>
                  <button type="button" className='btn btn-primary btn-sm' onClick={handleGifLoadMore}>Load More</button>
                </div>
              }
            </>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CnpSelectGifPopup;